import {Button} from 'primereact/button'
import {Dropdown} from 'primereact/dropdown'
import {useMemo} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'

const PaginatorTemplate = ({
    currentRecords = 0,
    totalRecords = 0,
    totalPages = 0,
    currentPage = 0,
    currentPageSize = 10,
    onPageChange = () => {},
    onPageSizeChange = () => {},
}) => {
    const totalCurrentRecords = useMemo(() => {
        let totalRecords = currentRecords + currentPageSize * currentPage

        return totalRecords
    }, [currentPage, currentPageSize, currentRecords])

    const {translateDatatable} = TranslateUtils()

    return (
        <div
            className="flex justify-content-between align-items-center px-3 border-round-bottom-xl"
            style={{
                backgroundColor: '#f8f9fa',
                height: '50px',
            }}>
            <div>
                <p>
                    {translateDatatable('Showing')} {totalCurrentRecords}{' '}
                    {translateDatatable('of')} {totalRecords}{' '}
                    {translateDatatable('records')}
                </p>
            </div>
            <div className="flex gap-1">
                <Button
                    icon="pi pi-angle-double-left text-green "
                    className="p-button-text p-button-plain"
                    onClick={() => onPageChange(0)}
                    disabled={currentPage < 1}
                />
                <Button
                    icon="pi pi-angle-left text-green "
                    className="p-button-text p-button-plain"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage < 1}
                />

                {Array.from(Array(totalPages).keys()).map(
                    item =>
                        (item < currentPage + 2 || item > currentPage - 2) && (
                            <Button
                                key={item}
                                label={item + 1}
                                className={`${
                                    currentPage === item ? 'font-bold' : ''
                                }`}
                                style={{
                                    color:
                                        currentPage === item
                                            ? 'white'
                                            : 'black',
                                    background:
                                        currentPage === item
                                            ? 'darkcyan'
                                            : 'lightgray',
                                    border: 'none',
                                    borderRadius: '50%',
                                }}
                                onClick={() => onPageChange(item)}
                            />
                        ),
                )}
                <Button
                    icon="pi pi-angle-right text-green "
                    className="p-button-text p-button-plain"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={
                        currentPage === totalPages - 1 || currentRecords === 0
                    }
                />
                <Button
                    icon="pi pi-angle-double-right text-green "
                    className="p-button-text p-button-plain"
                    onClick={() => onPageChange(totalPages - 1)}
                    disabled={
                        currentPage === totalPages - 1 || currentRecords === 0
                    }
                />
            </div>
            <div>
                <Dropdown
                    className="p-button-text p-button-plain text-gray-500"
                    options={[10, 20, 30, 40, 50]}
                    value={currentPageSize}
                    onChange={e => onPageSizeChange(e.value)}
                />
            </div>
        </div>
    )
}

export default PaginatorTemplate
